export const TRANSPARENT: string = 'transparent';

export const BLACK_1: string = 'rgba(0, 0, 0, 0.01)';
export const BLACK_3: string = 'rgba(0, 0, 0, 0.03)';
export const BLACK_5: string = 'rgba(0, 0, 0, 0.05)';
export const BLACK_10: string = 'rgba(0, 0, 0, 0.11)';
export const BLACK_20: string = 'rgba(0, 0, 0, 0.22)';
export const BLACK_30: string = 'rgba(0, 0, 0, 0.33)';
export const BLACK_40: string = 'rgba(0, 0, 0, 0.43)';
export const BLACK_50: string = 'rgba(0, 0, 0, 0.54)';
export const BLACK_60: string = 'rgba(0, 0, 0, 0.63)';
export const BLACK_70: string = 'rgba(0, 0, 0, 0.73)';
export const BLACK_80: string = 'rgba(0, 0, 0, 0.82)';
export const BLACK_90: string = 'rgba(0, 0, 0, 0.91)';
export const BLACK: string = '#000000';

export const WHITE_1: string = 'rgba(255, 255, 255, 0.01)';
export const WHITE_3: string = 'rgba(255, 255, 255, 0.03)';
export const WHITE_5: string = 'rgba(255, 255, 255, 0.05)';
export const WHITE_10: string = 'rgba(255, 255, 255, 0.09)';
export const WHITE_20: string = 'rgba(255, 255, 255, 0.18)';
export const WHITE_30: string = 'rgba(255, 255, 255, 0.27)';
export const WHITE_40: string = 'rgba(255, 255, 255, 0.37)';
export const WHITE_50: string = 'rgba(255, 255, 255, 0.46)';
export const WHITE_60: string = 'rgba(255, 255, 255, 0.57)';
export const WHITE_70: string = 'rgba(255, 255, 255, 0.67)';
export const WHITE_80: string = 'rgba(255, 255, 255, 0.78)';
export const WHITE_90: string = 'rgba(255, 255, 255, 0.89)';
export const WHITE: string = '#FFFFFF';

export const BLUE_1: string = '#F7FCFF';
export const BLUE_3: string = '#EFF9FF';
export const BLUE_5: string = '#E5F4FF';
export const BLUE_10: string = '#C6E8FF';
export const BLUE_20: string = '#88D0FF';
export const BLUE_30: string = '#00B4FF';
export const BLUE_40: string = '#0094FF';
export const BLUE_50: string = '#0073E7'; // Primary
export const BLUE_60: string = '#0058C8';
export const BLUE_70: string = '#003AA5';
export const BLUE_80: string = '#032281';
export const BLUE_90: string = '#011243';

export const PURPLE_1: string = '#FDFAFF';
export const PURPLE_3: string = '#FBF6FF';
export const PURPLE_5: string = '#F9F0FF';
export const PURPLE_10: string = '#EDDDFD';
export const PURPLE_20: string = '#E2B7FF';
export const PURPLE_30: string = '#D38FFF';
export const PURPLE_40: string = '#C265FF';
export const PURPLE_50: string = '#AD2EFF'; // Primary
export const PURPLE_60: string = '#8B00E7';
export const PURPLE_70: string = '#680AA7';
export const PURPLE_80: string = '#460871';
export const PURPLE_90: string = '#28023F';

export const MAGENTA_1: string = '#FFF9FD';
export const MAGENTA_3: string = '#FFF5FB';
export const MAGENTA_5: string = '#FFEDF8';
export const MAGENTA_10: string = '#FDD9EF';
export const MAGENTA_20: string = '#FDB0E0';
export const MAGENTA_30: string = '#FC81CE';
export const MAGENTA_40: string = '#FB44B6';
export const MAGENTA_50: string = '#DC1691'; // Primary
export const MAGENTA_60: string = '#B31374';
export const MAGENTA_70: string = '#850D57';
export const MAGENTA_80: string = '#5A083B';
export const MAGENTA_90: string = '#310520';


export const RED_1: string = '#FFFAFA';
export const RED_3: string = '#FFF5F4';
export const RED_5: string = '#FFECEA';
export const RED_10: string = '#FFDBD9';
export const RED_20: string = '#FFB5B0';
export const RED_30: string = '#FF8A82';
export const RED_40: string = '#FF574C';
export const RED_50: string = '#EA1000'; // Primary
export const RED_60: string = '#BD0E00';
export const RED_70: string = '#8E0800';
export const RED_80: string = '#620501';
export const RED_90: string = '#360301';

export const ORANGE_1: string = '#FFFBF9';
export const ORANGE_3: string = '#FFF4ED';
export const ORANGE_5: string = '#FFEFE5';
export const ORANGE_10: string = '#FFDDC7';
export const ORANGE_20: string = '#FFB788';
export const ORANGE_30: string = '#FF8C40';
export const ORANGE_40: string = '#F76100';
export const ORANGE_50: string = '#C85000';
export const ORANGE_60: string = '#9F4100';
export const ORANGE_70: string = '#762E00';
export const ORANGE_80: string = '#502000';
export const ORANGE_90: string = '#2A1100';

export const YELLOW_1: string = '#FFFCF5';
export const YELLOW_3: string = '#FFF7E5';
export const YELLOW_5: string = '#FFF1CF';
export const YELLOW_10: string = '#FFDF92';
export const YELLOW_20: string = '#FFBC1C';
export const YELLOW_30: string = '#E29E01';
export const YELLOW_40: string = '#BF8500';
export const YELLOW_50: string = '#9D6D00'; // Primary
export const YELLOW_60: string = '#7D5800';
export const YELLOW_70: string = '#5B4000';
export const YELLOW_80: string = '#3C2B00';
export const YELLOW_90: string = '#201700';

export const GREEN_1: string = '#F6FDF7';
export const GREEN_3: string = '#EAFBED';
export const GREEN_5: string = '#E0F7E5';
export const GREEN_10: string = '#C1EECD';
export const GREEN_20: string = '#7CDC92';
export const GREEN_30: string = '#32C353';
export const GREEN_40: string = '#28A648';
export const GREEN_50: string = '#228739'; // Primary
export const GREEN_60: string = '#1B6C2D';
export const GREEN_70: string = '#144F21';
export const GREEN_80: string = '#0C3416';
export const GREEN_90: string = '#061C0C';

export const TEAL_1: string = '#F8FCFC';
export const TEAL_3: string = '#EFF9F9';
export const TEAL_5: string = '#E5F6F4';
export const TEAL_10: string = '#C7E9E8';
export const TEAL_20: string = '#8ED4D0';
export const TEAL_30: string = '#49BBB4';
export const TEAL_40: string = '#22A199';
export const TEAL_50: string = '#1D837C'; // Primary
export const TEAL_60: string = '#176963';
export const TEAL_70: string = '#124D4A';
export const TEAL_80: string = '#0A3431';
export const TEAL_90: string = '#051B19';

export const GREY_1: string = '#FCFCFC';
export const GREY_3: string = '#F7F7F7';
export const GREY_5: string = '#F2F2F2';
export const GREY_10: string = '#E3E3E3';
export const GREY_20: string = '#C7C7C7';
export const GREY_30: string = '#ABABAB';
export const GREY_40: string = '#919191';
export const GREY_50: string = '#757575';
export const GREY_60: string = '#5E5E5E';
export const GREY_70: string = '#454545';
export const GREY_80: string = '#2E2E2E';
export const GREY_90: string = '#171717';

export enum BaseColorName {
  BLACK = 'BLACK',
  WHITE = 'WHITE',
  GREY = 'GREY',
  BLUE = 'BLUE',
  GREEN = 'GREEN',
  ORANGE = 'ORANGE',
  RED = 'RED',
  YELLOW = 'YELLOW',
}

export function getColorWithShade(baseColor: BaseColorName, shade: number): string {
  let color: string = baseColor;

  if (shade) color += `_${shade}`;

  // tslint:disable-next-line: no-eval
  return eval(color);
}
